<div class="encabezado">
  <div class="col-4 getBack">
    <a routerLink="/reports">
      <span
        ><i class="icon-chevron-left"></i
        >{{ "forms.buttons.back" | translate }}</span
      >
    </a>
  </div>

  <h5 class="titulo1">{{ "reports.not_delivered" | translate }}</h5>

  <!-- Botón Añadir — mismo estilo que orders -->
  <div class="d-flex justify-content-end mb-3">
    <div class="btn-izq">
      <button class="btn btn-hover" type="button" (click)="openCreateModal()">
        <span class="add-btn-text">{{ "buttons.add+" | translate }}</span>
        <i class="icon-plus"></i>
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Estado vacío -->
  <div
    *ngIf="!isLoading && tokens.length === 0"
    class="empty-state text-center py-5"
  >
    <i
      class="icon-inbox"
      style="font-size: 3rem; color: var(--color-gray-300, #ccc)"
    ></i>
    <p class="mt-3" style="color: var(--color-gray-500, #6c757d)">
      {{ "reports.no_tokens" | translate }}
    </p>
  </div>

  <!-- Tabla de tokens — mismo estilo que contrataciones -->
  <div *ngIf="!isLoading && tokens.length > 0" class="tabla">
    <div class="table-responsive-wrapper">
      <table mat-table [dataSource]="tokens" class="full-width-table">
        <!-- Supplier Column -->
        <ng-container matColumnDef="supplier">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.supplier" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span>{{ row.supplier?.name || "—" }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Orders Count Column -->
        <ng-container matColumnDef="orders_count">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "reports.pending_orders" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span class="badge text-badge-list text-bg-secondary">{{
                row.not_delivered_orders_count
              }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Without Expected Date Count Column -->
        <ng-container matColumnDef="without_date_count">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "reports.without_expected_date" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span class="badge text-badge-list"
                [ngClass]="row.not_delivered_without_expected_date_count > 0 ? 'text-canceled' : 'text-priority-0'">
                {{ row.not_delivered_without_expected_date_count || 0 }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Expires Column -->
        <ng-container matColumnDef="expires_at">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "reports.expires" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span>{{ formatDate(row.expires_at) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "reports.status" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span
                class="badge text-badge-list"
                [ngClass]="row.is_expired ? 'text-canceled' : 'text-priority-0'"
              >
                {{
                  (row.is_expired
                    ? "reports.token_expired"
                    : "reports.token_active"
                  ) | translate
                }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <i class="icon-eye text-primary icon-actions"
              [title]="'reports.view_orders' | translate"
              (click)="openSupplierOrders(row); $event.stopPropagation()"></i>
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              [title]="(row.is_expired ? 'reports.refresh_and_copy' : 'reports.copy_link') | translate"
              (click)="copyOrRefreshAndCopy(row, $event); $event.stopPropagation()"
              style="margin-left:8px;">
              <i [class]="row.is_expired ? 'icon-undo2' : 'icon-copy'"></i>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="clickable-row"
        ></tr>
      </table>
    </div>
  </div>
</div>
